import { createContext, useRef, useState } from "react";
import { io } from "socket.io-client";
import { SOCKET_ENDPOINT } from "../constant/index";

export const SocketIOContext = createContext();

export const SocketIOProvider = (props) => {
  const [socket, setSocket] = useState(null);
  const socketRef = useRef(null);
  const [data, setData] = useState(null);
  const [sensorTemperatures, setSensorTemperatures] = useState({});

  const connectSocket = () => {
    if (socketRef?.current && socketRef.current?.connected) return;

    socketRef.current = io(`${SOCKET_ENDPOINT}`, {
      //   auth: {
      //     token: getAccessToken(),
      //   },
      path: "/socket.io",
      forceNew: true,
      reconnectionAttempts: 100,
      timeout: 10000,
      transports: ["websocket"],
    });

    socketRef?.current?.on("connect", () => {
      console.log("socket.io connect", socketRef.current.id);
    });

    socketRef?.current?.on("disconnect", () => {
      console.log("socket.io disconnect", socketRef.current.id);
    });
    socketRef?.current?.on("newSensorData", (data) => {
      console.log("New sensor data received:", data);

      setSensorTemperatures((prevData) => ({
        ...prevData,
        [data?.device_eui]: data?.temperature, // Update temperature for the specific sensor
      }));
      console.log("battery", data.battery);
      // You can now update the UI or process the received data
      // Example: Display the new temperature
    });
    socketRef?.current?.on("welcome", () => {
      console.log("socket.io welcome", socketRef.current.id);
    });
    setSocket(socketRef.current);
  };

  const disconnectSocket = () => {
    if (socket) {
      socket.removeAllListeners();
      socket.disconnect();
      socket.close();
    }
  };

  return (
    <SocketIOContext.Provider
      value={{
        data,
        socket,
        sensorTemperatures,
        connectSocket,
        disconnectSocket,
      }}
    >
      {props?.children}
    </SocketIOContext.Provider>
  );
};
